import { Injectable, Inject, RendererFactory2, Renderer2, RendererType2 } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable()
export class Head {
    constructor(
        @Inject(DOCUMENT)
        private _doc : any,
        private rendererFactory : RendererFactory2
    ) {
        this.renderer = this.rendererFactory.createRenderer(_doc, null);
    }

    private renderer : Renderer2;

    addLink(rel : string, type : string, href : string, title : string = null) : any {
        let link = this.renderer.createElement('link');
        this.renderer.setAttribute(link, 'rel', rel);
        this.renderer.setAttribute(link, 'type', type);
        this.renderer.setAttribute(link, 'href', href);

        if (title)
            this.renderer.setAttribute(link, 'title', title);
        
        this.renderer.appendChild(this._doc.head, link);

        return link;
    }

    removeLink(link : any) {
        this.renderer.removeChild(this._doc.head, link);
    }
}